import { visserApi } from "./visserApi";
const getAllBrands = async () => {
    return await visserApi.get('Merk/GetAll');
};
const brandApi = {
    getAllBrands
};
export default brandApi;
